// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2caf7dd4","455":"201ebebe","977":"5b41bd66"}[chunkId] + ".chunk.js";
};